import Enum from 'config/enum';

const ADMIN_SPACE_DATA_TAB = {
    DATA: 'data',
    LABEL_MEMBER: 'label-member',
    LABEL_DOCUMENT: 'label-document',
    LABEL_SEAL: 'label-seal',
};

// 스페이스 관리자 > 시스템 설정
export const WS_ADMIN_SETTING_TAB = {
    API: 'API',
    WEBHOOK: 'WEBHOOK',
    HISTORY: 'HISTORY',
};

// 삭제 항목 (WSAdmin · System 공용)
export const DELETED_RESOURCE_TAB = {
    SEAL: 'SEAL',
    TEMPLATE: 'TEMPLATE',
    DOCUMENT: 'DOCUMENT',
};

export const createRoutePath = (contextPath) => ({
    ROOT: contextPath,
    SIGN_IN: contextPath + 'signin',
    WORKSPACE_CREATE: contextPath + 'workspace/create',

    MEMBER_HOME: contextPath + 'member/home',
    MEMBER_INFO: contextPath + 'member/info',
    MEMBER_STAMP: contextPath + 'member/stamp',

    MEMBER_DRAFT_DOCUMENT: contextPath + 'member/draft-document',

    MEMBER_DOCUMENT: contextPath + 'member/document',
    MEMBER_DOCUMENT_APPROVE: contextPath + 'member/document-approve',
    MEMBER_DOCUMENT_SEAL_APPROVE: contextPath + 'member/document-seal-approve',
    MEMBER_DOCUMENT_SEAL: contextPath + 'member/document-seal',

    MEMBER_DEPARTMENT_TEMPLATE_DOCUMENT: contextPath + 'member/head/template-document',
    MEMBER_DEPARTMENT_PUBLISH_DOCUMENT: contextPath + 'member/head/publish-document',
    MEMBER_DEPARTMENT_DRAFT_DOCUMENT: contextPath + 'member/head/draft-document',
    MEMBER_DEPARTMENT_RECEIVED_DOCUMENT: contextPath + 'member/head/received-document',
    MEMBER_DEPARTMENT_DESIGN_TEMPLATE_DOCUMENT: contextPath + 'member/head/design/template-document',
    MEMBER_DEPARTMENT_DETAIL_DOCUMENT: contextPath + 'member/head/detail/document',

    MEMBER_DESIGN_DRAFT_DOCUMENT: contextPath + 'member/design/draft-document',
    MEMBER_DESIGN_PUBLISH_DOCUMENT: contextPath + 'member/publish/draft-document',
    MEMBER_DETAIL_DOCUMENT: contextPath + 'member/detail/document',

    ADMIN_DASHBOARD: contextPath + 'admin/dashboard',
    ADMIN_MEMBER: contextPath + 'admin/member',
    ADMIN_STAMP: contextPath + 'admin/stamp',
    ADMIN_TEMPLATE_DOCUMENT: contextPath + 'admin/template-document',
    ADMIN_DEPARTMENT_TEMPLATE: contextPath + 'admin/department-template',
    ADMIN_SPACE_DATA: contextPath + 'admin/space-data',
    ADMIN_DOCUMENT: contextPath + 'admin/document',
    ADMIN_DOCUMENT_SEAL_LOG: contextPath + 'admin/document-seal-log',

    ADMIN_DESIGN_TEMPLATE_DOCUMENT: contextPath + 'admin/design/template-document',
    ADMIN_DETAIL_DOCUMENT: contextPath + 'admin/detail/document',

    WS_ADMIN_SETTING: contextPath + 'admin/setting',
    WS_ADMIN_DELETED: contextPath + 'admin/deleted',

    SYSTEM_ROOT: contextPath + 'system',
    SYSTEM_DASHBOARD: contextPath + 'system/dashboard',
    SYSTEM_WORKSPACE: contextPath + 'system/workspace',
    SYSTEM_USER: contextPath + 'system/user',
    SYSTEM_DOCUMENT: contextPath + 'system/document',
    SYSTEM_DELETED_RESOURCE: contextPath + 'system/deleted',

    EXTERNAL_VIEW_TEMPLATE_DOCUMENT: contextPath + 'external/view/template-document',
    EXTERNAL_VIEW_DRAFT_DOCUMENT: contextPath + 'external/view/draft-document',
    EXTERNAL_VIEW_DOCUMENT: contextPath + 'external/view/document',
});

export const createExternalRoutePath = (routePath) => [
    routePath.EXTERNAL_VIEW_TEMPLATE_DOCUMENT,
    routePath.EXTERNAL_VIEW_DRAFT_DOCUMENT,
    routePath.EXTERNAL_VIEW_DOCUMENT,
];

export const createRoutePathGroup = (routePath) => ({
    [routePath.MEMBER_DOCUMENT]: [
        `${routePath.MEMBER_DOCUMENT}`,
        `${routePath.MEMBER_DOCUMENT}/PROGRESS`,
        `${routePath.MEMBER_DOCUMENT}/COMPLETE`,
        `${routePath.MEMBER_DOCUMENT}/CLOSE`,
        `${routePath.MEMBER_DOCUMENT}/ALL`,
    ],

    [routePath.MEMBER_DOCUMENT_APPROVE]: [
        `${routePath.MEMBER_DOCUMENT_APPROVE}`,
        `${routePath.MEMBER_DOCUMENT_APPROVE}/PROGRESS`,
        `${routePath.MEMBER_DOCUMENT_APPROVE}/ALL`,
    ],
    [routePath.MEMBER_DOCUMENT_SEAL_APPROVE]: [
        `${routePath.MEMBER_DOCUMENT_SEAL_APPROVE}`,
        `${routePath.MEMBER_DOCUMENT_SEAL_APPROVE}/PROGRESS`,
        `${routePath.MEMBER_DOCUMENT_SEAL_APPROVE}/ALL`,
    ],
    [routePath.MEMBER_DOCUMENT_SEAL]: [
        `${routePath.MEMBER_DOCUMENT_SEAL}`,
        `${routePath.MEMBER_DOCUMENT_SEAL}/PROGRESS`,
        `${routePath.MEMBER_DOCUMENT_SEAL}/ALL`,
    ],
    [routePath.ADMIN_SPACE_DATA]: [
        `${routePath.ADMIN_SPACE_DATA}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.DATA}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_MEMBER}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_MEMBER}/${Enum.BE_LABEL_TYPE.MEMBER_TYPE}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_MEMBER}/${Enum.BE_LABEL_TYPE.MEMBER_POSITION}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_MEMBER}/${Enum.BE_LABEL_TYPE.MEMBER_RESPONSIBILITY}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_SEAL}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_SEAL}/${Enum.BE_LABEL_TYPE.SEAL_TYPE}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_DOCUMENT}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_DOCUMENT}/${Enum.BE_LABEL_TYPE.DOCUMENT_TYPE}`,
        `${routePath.ADMIN_SPACE_DATA}/${ADMIN_SPACE_DATA_TAB.LABEL_DOCUMENT}/${Enum.BE_LABEL_TYPE.APPROVAL_REQUEST_REASON}`,
    ],
    [routePath.ADMIN_DOCUMENT]: [
        `${routePath.ADMIN_DOCUMENT}`,
        `${routePath.ADMIN_DOCUMENT}/PROGRESS`,
        `${routePath.ADMIN_DOCUMENT}/COMPLETE`,
        `${routePath.ADMIN_DOCUMENT}/CLOSE`,
        `${routePath.ADMIN_DOCUMENT}/ALL`,
    ],
    [routePath.ADMIN_DOCUMENT_SEAL_LOG]: [
        `${routePath.ADMIN_DOCUMENT_SEAL_LOG}`,
        `${routePath.ADMIN_DOCUMENT_SEAL_LOG}/ALL`,
        `${routePath.ADMIN_DOCUMENT_SEAL_LOG}/LEDGER`,
    ],
    [routePath.WS_ADMIN_SETTING]: [
        `${routePath.WS_ADMIN_SETTING}`,
        `${routePath.WS_ADMIN_SETTING}/${WS_ADMIN_SETTING_TAB.API}`,
        `${routePath.WS_ADMIN_SETTING}/${WS_ADMIN_SETTING_TAB.WEBHOOK}`,
        `${routePath.WS_ADMIN_SETTING}/${WS_ADMIN_SETTING_TAB.HISTORY}`,
    ],
    [routePath.WS_ADMIN_DELETED]: [
        `${routePath.WS_ADMIN_DELETED}`,
        `${routePath.WS_ADMIN_DELETED}/${DELETED_RESOURCE_TAB.SEAL}`,
        `${routePath.WS_ADMIN_DELETED}/${DELETED_RESOURCE_TAB.TEMPLATE}`,
        `${routePath.WS_ADMIN_DELETED}/${DELETED_RESOURCE_TAB.DOCUMENT}`,
    ],
    [routePath.SYSTEM_DELETED_RESOURCE]: [
        `${routePath.SYSTEM_DELETED_RESOURCE}`,
        `${routePath.SYSTEM_DELETED_RESOURCE}/${DELETED_RESOURCE_TAB.SEAL}`,
        `${routePath.SYSTEM_DELETED_RESOURCE}/${DELETED_RESOURCE_TAB.TEMPLATE}`,
        `${routePath.SYSTEM_DELETED_RESOURCE}/${DELETED_RESOURCE_TAB.DOCUMENT}`,
    ],
});

export const isExternalPath = (routePathExternal, pathname) => (
    routePathExternal.some((path) => pathname.startsWith(path))
);
